var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcEmptyContent',{attrs:{"name":_vm.t('mail', 'No messages in this mailbox')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconMail',{attrs:{"size":65}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }